import gql from 'graphql-tag'

export const DELETE = gql`
  mutation price_delete($id: ID!) {
    priceDelete(id: $id) {
      id
    }
  }
`
